import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from 'lib/api-client';
import { QueryConfig } from 'lib/react-query';
import { ToolGroup } from 'types/api';

type GetToolGroupResponse = {
    tool_group: ToolGroup;
};

export const getToolGroup = async (id: string): Promise<ToolGroup> => {
    const response = await api.get<GetToolGroupResponse, GetToolGroupResponse>(
        `/app/api/v1/tool_group/${id}`,
    );
    return response.tool_group;
};

export const getToolGroupQueryOptions = (id: string) => {
    return queryOptions({
        queryKey: ['toolGroup', id],
        queryFn: () => getToolGroup(id),
    });
};

type UseToolGroupOptions = {
    id: string;
    queryConfig?: QueryConfig<typeof getToolGroupQueryOptions>;
};

export const useToolGroup = ({ id, queryConfig }: UseToolGroupOptions) => {
    return useQuery({
        ...getToolGroupQueryOptions(id),
        ...queryConfig,
    });
};
